module.exports = __webpack_public_path__ + "140ab50de7168eaa710b1ce14fcf14e5.svg";